<template>
  <div class="header-holder">
    <!-- Order Success Here -->
    <div v-if="isConfirmedOrder" class="success editorial">
      <span>
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="13.5" cy="13.5" r="13.5" fill="#68C67E" />
          <path d="M8 12.7619L12.4444 18L18 8" stroke="#232220" />
        </svg>
      </span>

      <p>Success! Your order has been placed.</p>
    </div>

    <div v-if="Object.keys(recipient).length || cardMessage" class="row">
      <!-- Address Region Here -->
      <div class="column-address" v-if="Object.keys(recipient).length">
        <AddressItem
          :recipient="recipient"
          :trackingNumber="order.trackingNumber"
          :trackingURL="order.trackingUrl"
          :showEditButtons="showEditButtons"
          :isOrderDetail="isOrderDetail"
          :selectedShippingRate="selectedShippingRate"
        />
      </div>

      <!-- Card Message Region Here -->
      <div
        v-if="cardMessage"
        class="column-card"
        :class="{
          'ml-0': recipientType === 'multiple'
        }"
      >
        <CardMessage
          :cardMessage="cardMessage"
          :showEditButtons="showEditButtons"
          :isOrderDetail="isOrderDetail"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AddressItem from '@/components/Universal/AddressItem'
import CardMessage from '@/components/Universal/CardMessage'

export default {
  name: 'OrderDetailHeader',
  props: {
    order: {
      type: Object,
      required: true,
      default: () => {}
    },
    recipient: {
      type: Object,
      required: true,
      default: () => {}
    },
    cardMessage: {
      type: String,
      default: ''
    },
    showEditButtons: {
      type: Boolean,
      defaul: false
    },
    recipientType: {
      type: String,
      default: ''
    },
    isConfirmedOrder: {
      type: Boolean,
      default: false
    },
    selectedShippingRate: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    AddressItem,
    CardMessage
  },

  computed: {
    isOrderDetail() {
      return !!this.$route.params.id
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.header-holder {
  margin-top: 1rem;
}

.success {
  display: flex;
  align-items: center;
  text-align: left;
  margin: 1.25rem 0;

  p {
    font-size: 1.25rem;
    font-weight: normal;
    padding-top: 6px;
    margin-left: 10px;
  }
}

.row {
  display: flex;
  margin-bottom: 3rem;
  margin-top: 0rem;
  justify-content: space-between;
}

.column-address {
  width: 100%;
}

.column-card {
  width: 100%;
  margin-left: 2rem;

  &.ml-0 {
    margin-left: 0;
  }
}

.has-border {
  border: 1px solid #232220;
}

@media screen and (max-width: 1100px) and (min-width: 350px) {
  .row {
    flex-direction: column;
  }

  .column-address {
    width: 100%;
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .column-card {
    width: 100%;
    margin-left: 0rem;
  }
}
</style>
